import { render, staticRenderFns } from "./TalkTrendStatTable.vue?vue&type=template&id=2326222b"
import script from "./TalkTrendStatTable.vue?vue&type=script&lang=js"
export * from "./TalkTrendStatTable.vue?vue&type=script&lang=js"
import style0 from "./TalkTrendStatTable.vue?vue&type=style&index=0&id=2326222b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports